<div *ngIf="itemCount > -1 " class="kolaConfigurationPopupSec" id="kolaConfigPopupSec">
  <a (click)="closeDialog()" class="md-dialog-close waves-effect closebtncls">
    <i class="material-icons btn-floating btn-small waves-effect waves-light cross-icon-bg"></i>
  </a>
  <div id="kolaConfigContentSec">
    <h2 md-dialog-title>Domain Configuration</h2>
    <md-dialog-content>
      <p  class="nodataFound no-data" *ngIf="itemCount == 0">No System Found. Please add first.</p>
      <md-accordion *ngIf="itemCount > 0">
        <md-expansion-panel [expanded]="expandPanel == i" (opened)="onOpen(i, item.id)" *ngFor="let item of items;let i = index;">
          <md-expansion-panel-header>
            <md-panel-title>
              <p>
                <span class="ser-no-cls">Serial Number</span>
                <span class="ser-no-val-cls">{{item.serialNumber}}</span>
              </p>
              <p>
                <span class="ser-no-cls">Mac address</span>
                <span class="ser-no-val-cls">{{item.macAddress}}</span>
              </p>
              <p>
                <span class="ser-no-cls">Koala ID</span>
                <span class="ser-no-val-cls">{{item.koalaId ? item.koalaId : '---'}}</span>
              </p>
            </md-panel-title>
          </md-expansion-panel-header>
          <div class="row">
            <form id="domain-config" action="" [formGroup]="form">
              <div class="col s12 m6 l6">
                <div class="errorZoneSec">
                  <h6 class="popup-subtitle-cls">Whitelist Domains</h6>
                  <md-form-field>
                    <textarea mdInput formControlName="whiteList"></textarea>
                  </md-form-field>
                  <p class="validate">{{error}}</p>
                </div>
              </div>
              <div class="col s12 m6 l6">
                <h6 class="popup-subtitle-cls">Blacklist Domains</h6>
                <md-form-field>
                  <textarea mdInput formControlName="blackList"></textarea>
                </md-form-field>
              </div>
              <div class="col s12 m12 l12">
                <button [disabled] = "isSaveDisable" md-raised-button class="glbAdminBtnCls1" type="submit" (click)="onSaveDomain(item.id)">SAVE</button>
                <button md-raised-button class="glbAdminBtnCls1" (click)="onCancel(i)">CANCEL</button>
              </div>
            </form>
          </div>
        </md-expansion-panel>
      </md-accordion>
    </md-dialog-content>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-domain/adm-manage-domain.component.html